export default {
  computed: {
    // watch で監視するため、代表で最初のパーツのスタイルを取得
    firstPartStyles () {
      if (!this.partsContainer) return null
      return this.partsContainer.parts[0].styles
    },
    // watch で監視するため、代表で最初のパーツのSNS表示タイプを取得
    firstPartDisplaySns () {
      if (!this.partsContainer) return null
      return this.partsContainer.parts[0].attrs['data-display-sns']
    },
    // watch で監視するため、代表で最初のパーツのアイコンサイズを取得
    firstPartIconSizeSns () {
      if (!this.partsContainer) return null
      return this.partsContainer.parts[0].attrs['width']
    },
    // watch で監視するため、アイコンスタイル(src-type)を取得
    iconStyleSns () {
      if (!this.partsContainer) return null
      return this.partsContainer.src_type
    },
    partsContainerAlign () {
      return this.partsContainer ? this.partsContainer.styles['align'] : 'center'
    },
    partsContainerLayoutType () {
      if (!this.partsContainer) return null
      return this.partsContainer.layout_type
    },
    containerStyles () {
      if (!this.styles) return null
      return { 'background': this.styles['background'], 'border': this.styles['border'] }
    },
  },
  methods: {
    // 最初のパーツと同じスタイルを、他の全てのパーツに適用させる
    updatePartsStyles (styles) {
      if (!styles) return
      // 最初のパーツを飛ばして、インデックス1番からループさせる
      for (let count = 1; count <= this.parts.length - 1; count++) {
        this.$store.commit('updatePart', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          partId: this.parts[count].id,
          styles,
        })
      }
    },
    // 最初のパーツと同じSNS表示タイプを、他の全てのパーツに適用させる
    updatePartsAttrs (display, attrs) {
      if (!display) return
      // 最初のパーツを飛ばして、インデックス1番からループさせる
      for (let count = 1; count <= this.parts.length - 1; count++) {
        this.$store.commit('updatePart', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          partId: this.parts[count].id,
          attrs: attrs,
        })
      }
    },
  },
  watch: {
    firstPartStyles: {
      deep: true,
      handler: function (styles) {
        if (styles) this.updatePartsStyles(styles)
      }
    },
    firstPartDisplaySns (display) {
      if (display) this.updatePartsAttrs(display, { 'data-display-sns': display })
    },
    firstPartIconSizeSns (display) {
      if (display) this.updatePartsAttrs(display, { 'width': display, 'height': display })
    },
    iconStyleSns (display) {
      if (display) this.updatePartsAttrs(display, {})
    },
  },
}
